import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MaterialTable from "material-table";
import {
  MuiThemeProvider,
  createMuiTheme,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import { KeyboardDatePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";

import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
  onSnapshot,
} from "firebase/firestore";

// import {
//   getAllAddressAPICall,
//   getAddress,
//   getZones,
//   getWards,
// } from "../../Address";


import { GetDailyReport, GetLampErrorReport } from "./ReportManager";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import PoleDataService from "../../apis/pole-data";
import { NotificationManager } from "react-notifications";
import DeviceAddressService from "../../apis/device-address";
import { db, getCheckSession } from "../../apis/auth";
import { deviceModeCode, serviceType } from "../../constants/constants";
import DeviceDataService from "../../apis/device-data";
import { exportMaterialTableToExcel, exportMaterialTableToPDF, format2Decimals, getDateString, getDateStringHHMMSS } from "../../utilities/utility";
import { CircularProgress } from "@material-ui/core";
import { Box } from "@mui/material";

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

const LampFailureReport = (props) => {
  // let app = null;
  // let db = null;
  // const firebaseConfigApiResponse = localStorage.getItem(
  //   "firebaseConfigApiResponse"
  // );
  // if (firebaseConfigApiResponse) {
  //   console.log("firebaseConfigApiResponse : ", firebaseConfigApiResponse);
  //   if (!getApps().length) {
  //     app = initializeApp(JSON.parse(firebaseConfigApiResponse));
  //   }
  //   db = getFirestore();
  // }

  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const startOfDay = new Date(yesterday);
  startOfDay.setHours(0, 0, 0, 0);
  const endOfDay = new Date(yesterday);
  endOfDay.setHours(23, 59, 59, 0);
  const [filterObj, setFilterObj] = useState({
    zone: 0,
    ward: 0,
    ccms: 0,
    startDate: startOfDay,
    endDate: endOfDay,
  });
  const [zoneFilterList, setZoneFilterList] = useState([]);
  const [wardFilterList, setWardFilterList] = useState([]);
  const [ccmsFilterList, setCcmsFilterList] = useState([]);

  const [masterCcmsFilterList, setMasterCcmsFilterList] = useState([]);

  //   const [dashboardReportData, setDashboardReportData] = useState([]);
  const [dashboardReportRawData, setDashboardReportRawData] = useState([]); //TODO: can be removed
  const [opReportData, setOpReportData] = useState([]);

  useEffect(async () => {
    console.log("========== Report : OnInit() ==========");
    var sessionStatus = await getCheckSession();
    if (sessionStatus === false) {
      history.push("/");
      return;
    }

    await DeviceAddressService.getInstance().getAllAddressAPICall();
    await PoleDataService.initService();
    let zoneList = DeviceAddressService.getInstance().getZones();
    let wardList = DeviceAddressService.getInstance().getWards(zoneList[0].value);
    setZoneFilterList(zoneList);
    setWardFilterList(wardList);
    console.log(`==> Zone list ${zoneList}\n\n WardList = ${wardList}`);
    setFilterObj((prevState) => ({
      ...prevState,
      zone: zoneList[0].value,
      ward: wardList[0].value,
    }));

    // setTimeout(() => {
    // getAllDevicesAPICall();
    //   getAllDeviceSummaryAPICall();
    // const treeZoneList = getZones();
    // const zoneList = treeZoneList.map((item) => ({
    //   label: item.value,
    //   value: item.id,
    //   // id: item.id
    // }));
    // console.log("getZones : ", zoneList);
    // setZoneFilterList(zoneList || []);
    // }, 3000);

    DeviceDataService.getInstance().initService(onFetchComplete, () => {

    }/*iterateDeviceHandler*/);
  }, []);

  async function onFetchComplete() {
    console.log(`========= EnergySaving : onFetchComplete()`);
    let deviceListIds = await updateDeviceFilterList();
    setFilterObj((prevState) => ({
      ...prevState,
      ccms: deviceListIds[0].value,
    }));
  }

  function iterateDeviceHandler(record, changeType) {
    console.log(`========= EnergySaving : iterateDeviceHandler() =========== record = ${JSON.stringify(record)}`);
    if (record !== null | undefined) {
      if (changeType === "added") {
        let filterRawData = [...ccmsFilterList];
        filterRawData.push(record);
        setCcmsFilterList(filterRawData);

      } else if (changeType === "modified") {
        let filterRawData = [...ccmsFilterList];
        var filterIndex = filterRawData.findIndex(item => item.value == record.dev_id);
        filterRawData[filterIndex] = record;
        setCcmsFilterList(filterRawData);

      } else if (changeType === "removed") {
        let filterRawData = [...ccmsFilterList];
        var filterIndex = filterRawData.findIndex(item => item.value == record.dev_id);
        filterRawData.splice(filterIndex, 1);
        setCcmsFilterList(filterRawData);
      }
    }
  }

  async function updateDeviceFilterList(zoneId = 0, wardId = 0, ccms = 0) {
    // const { zoneId: zoneId = 0, wardId: wardId = 0, ccms: ccms = 0 } = filterObj;
    const { deviceListIds: deviceListIds = [], deviceList: deviceList = [], errorDeviceList: errorDeviceList = [] } = await DeviceDataService.getInstance().getDevicesByFilter(zoneId, wardId, ccms);
    setCcmsFilterList(deviceListIds);
    return deviceListIds;
    // setFilterObj((prevState) => ({
    //   ...prevState,
    //   ccms: deviceListIds[0].value,
    // }));
  }

  const getOpReportColumnList = () => {
    return [
      {
        title: 'DATE',
        cellStyle: {
          whiteSpace: 'nowrap'
        },
        render: ({ date = 'N/A' }) => {
          if (date !== 'N/A') {
            const d = new Date(date);
            const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Get month and pad with leading zero if needed
            const day = d.getDate().toString().padStart(2, '0'); // Get day and pad with leading zero if needed
            const year = d.getFullYear(); // Get full year

            return `${day}/${month}/${year}`; // Format as MM/DD/YYYY
          }
          return 'N/A';
        },
        exportTransformer: ({ date: date = 'N/A' }) => {
          return date.toLocaleString();
        },
      },
      {
        title: 'Lamp UID',
        // field: "zone",
        cellStyle: {
          whiteSpace: 'nowrap'
        },
        render: ({ lamp_uid: lamp_uid = '', }) => {
          return lamp_uid;
        },
        exportTransformer: ({ lamp_uid: lamp_uid = '' }) => {
          return lamp_uid;
        },
      },
      {
        title: 'ILM UID',
        cellStyle: {
          whiteSpace: 'nowrap'
        },
        // field: "ward",
        render: ({ lim_uid: lim_uid = "NA", }) => {
          return lim_uid;
        },
        exportTransformer: ({ lim_uid: lim_uid = 'NA', }) => {
          return lim_uid;
        },
      },
      {
        title: 'Watts',
        // field: "sc_no",
        render: ({ wt: wt = 'N/A' }) => {
          return wt;
        },
        exportTransformer: ({ wt: wt = 'N/A' }) => {
          return wt;
        },
      },
      {
        title: 'SLC UID',
        cellStyle: {
          whiteSpace: 'nowrap'
        },
        // field: "sim_no",
        render: ({ slc_uid: slc_uid = 'N/A' }) => {
          return slc_uid;
        },
        exportTransformer: ({ slc_uid: slc_uid = 'N/A' }) => {
          return slc_uid;
        },
      },
      {
        title: 'Ward',
        // field: "dev_id",
        render: ({ wd: wd = 'NA' }) => {
          return wd;
        },
        exportTransformer: ({ wd: wd = 'NA' }) => {
          return wd;
        },
      },
      {
        title: 'Zone',
        // field: "dev_id",
        render: ({ zn: zn = 'NA' }) => {
          return zn;
        },
        exportTransformer: ({ zn: zn = 'NA' }) => {
          return zn;
        },
      },
      {
        title: 'Address',
        render: ({ addr: addr = 'NA' }) => {
          return addr;
        },
        exportTransformer: ({ addr: addr = 'NA' }) => {
          return addr;
        },
      },

      {
        title: 'GPS Locatoon',
        cellStyle: {
          whiteSpace: 'nowrap'
        },
        // field: "esp",
        render: ({ location: location = "NA" }) => {
          return `${location}`;
        },
        exportTransformer: ({ location: location = "COM" }) => {
          return `${location}`;
        },
      },
      {
        title: 'STATUS',
        cellStyle: {
          whiteSpace: 'nowrap'
        },
        // field: "esp",
        render: ({ dev_st: dev_st = "COM" }) => {
          return `${dev_st}`;
        },
        exportTransformer: ({ dev_st: dev_st = "COM" }) => {
          return `${dev_st}`;
        },
      },
    ];
  };

  const handleDateChange = (date, dateField) => {
    setFilterObj((prevState) => ({
      ...prevState,
      [dateField]: date,
    }));
  };

  const handleFilterChange = async (e) => {
    const { target: { name = "", value = "" } = {} } = e;
    console.log(`handleFilterChange -> ${name} = ${value}`);
    if (name === "zone") {
      let wardList = DeviceAddressService.getInstance().getWards(value);
      setWardFilterList(wardList);

      // // var deviceListIds = dashboardReportRawData
      // //     .filter((item) => item.zn_id === value)
      // //     .map((item) => ({
      // //       label: item.dev_id,
      // //       value: item.dev_id,
      // //     })) || [];

      // let records = dashboardReportRawData.filter((item) => item.zn_id === value) || [];
      // let deviceListIds = [{label: "All",value: 0}]
      // for (let item of records) {
      //   deviceListIds.push({
      //     label: item.dev_id,
      //     value: item.dev_id,
      //   });
      // }
      // setCcmsFilterList(deviceListIds);

      let deviceListIds = await updateDeviceFilterList(value, wardList[0].value);
      setFilterObj((prevState) => ({
        ...prevState,
        zone: value,
        ward: wardList[0].value,
        ccms: deviceListIds[0].value,
      }));
    } else if (name === "ward") {
      // const { deviceListIds:deviceListIds = [], deviceList: deviceList = [], errorDeviceList: errorDeviceList = [] } = await DeviceDataService.getInstance().getDevicesByFilter(zone, value);
      // setCcmsFilterList(deviceListIds);
      // let records = dashboardReportRawData.filter((item) => item.zn_id === zone && item.wd_id === value) || [];
      // let deviceListIds = [{label: "All",value: 0}]
      // for (let item of records) {
      //   deviceListIds.push({
      //     label: item.dev_id,
      //     value: item.dev_id,
      //   });
      // }
      // setCcmsFilterList(deviceListIds);
      const { zone: zone = 0 } = filterObj;
      let deviceListIds = await updateDeviceFilterList(zone, value);
      setFilterObj((prevState) => ({
        ...prevState,
        ward: value,
        ccms: deviceListIds[0].value,
      }));
    } else if (name === "ccms") {
      setFilterObj((prevState) => ({
        ...prevState,
        ccms: value,
      }));
    }
  };

  const handleFilterApply = async () => {

    const {
      startDate = new Date(),
      endDate = new Date(),
      zone = 0,
      ward = 0,
      ccms = 0,
    } = filterObj;
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 0);
    const currentDate = new Date();
    currentDate.setHours(23, 59, 59, 0)
    if (startDate > endDate) {
      NotificationManager.error("Please select a valid date range", "", 3000);
      return;
    }
    if (endDate > currentDate) {
      NotificationManager.error("End date cannot be in the future", "", 3000);
      return;
    }
    setLoading(true);
    GetLampErrorReport(startDate, endDate, zone, ward).then((reportList) => {
      if (reportList && reportList.length > 0) {
        setOpReportData([...reportList]);
        setLoading(false);
      } else {
        NotificationManager.error("No lamp failure records found.", "", 3000);
        setLoading(false);
      }
    }).catch((error) => {
      setLoading(false)
      console.log(error)
      console.log('Energy Saving Report==> ', error.message);
      alert("Unable to complete your request. Please try after sometime.");
    });
    // getAllDeviceSummaryAPICall();
  };

  const getAllDevicesAPICall = async (zoneId = 0, wardId = 0) => {
    let reportList = [];
    let ccmsFilterList = [{ label: "All", value: 0 }];
    let q = null;
    q = query(collection(db(), "devices"));

    // const q = query(collection(db, "devices"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {

      console.log("users docs : ", doc.data());
      let record = doc.data();
      const {
        dev_id: ccmsNumber = "",
        dev_ml: phase = 0,
        loc: coords = "",
        loc: { _lat: latitude = 0, _long: longitude = 0 } = {},
        dev_st: status = 0,
        errors = [],
        err_cnt: errorsCount = 0,
        dev_md: mode = 0,
        ls: date = "",
        lmp_cnt: lampCount = 0,
        lmp_off_cnt: lampOffCount = 0,
        zn_id: zoneId = 0,
        wd_id: wardId = 0,
        pl_id: placeId = 0,
        st_id: streetId = 0,
      } = record;

      reportList = [...reportList, record];
      ccmsFilterList = [
        ...ccmsFilterList,
        {
          label: ccmsNumber,
          value: ccmsNumber,
        },
      ];
    });
    setDashboardReportRawData([...reportList]);
    setMasterCcmsFilterList([...ccmsFilterList]);
    setCcmsFilterList([...ccmsFilterList]);
  };

  const {
    startDate = new Date(),
    endDate = new Date(),
    zone: zoneFilter = 0,
    ward: wardFilter = 0,
    ccms: ccmsFilter = 0,
  } = filterObj;

  return (
    <div className="reports">
      {loading && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            zIndex: 9999, // To ensure it's on top of other elements
            // backgroundColor: 'rgba(255, 255, 255, 0.8)', // Optional: Adds a translucent background
          }}
        >
          <CircularProgress disableShrink />
        </Box>
      )}
      <h2 className="reports-header">Lamp Failure Report</h2>
      <Grid container className="reports-filter-wrapper">
        {/* <Grid xs={12} sm={3} className="reports-date-filter">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              clearable
              autoOk
              label="Start Date"
              value={startDate}
              placeholder="dd/MM/yyyy"
              InputAdornmentProps={{ position: "end" }}
              onChange={(date) => handleDateChange(date, "startDate")}
              variant="inline"
              inputVariant="outlined"
              // minDate={new Date()}
              format="dd/MM/yyyy"
            />
          </MuiPickersUtilsProvider>
        </Grid> */}
        {/* <Grid xs={12} sm={3} className="reports-date-filter">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              clearable
              autoOk
              label="End Date"
              value={endDate}
              placeholder="dd/MM/yyyy"
              InputAdornmentProps={{ position: "end" }}
              onChange={(date) => handleDateChange(date, "endDate")}
              variant="inline"
              inputVariant="outlined"
              // minDate={new Date()}
              format="dd/MM/yyyy"
            />
          </MuiPickersUtilsProvider>
        </Grid> */}
        <Grid xs={12} sm={12}>
          <div className="reports-zw-filter">
            <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  clearable
                  autoOk
                  label="Start Date"
                  value={startDate}
                  placeholder="dd/MM/yyyy"
                  InputAdornmentProps={{ position: "end" }}
                  onChange={(date) => handleDateChange(date, "startDate")}
                  variant="inline"
                  inputVariant="outlined"
                  // minDate={new Date()}
                  format="dd/MM/yyyy"
                />
              </MuiPickersUtilsProvider>
            </FormControl>
            <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  clearable
                  autoOk
                  label="End Date"
                  value={endDate}
                  placeholder="dd/MM/yyyy"
                  InputAdornmentProps={{ position: "end" }}
                  onChange={(date) => handleDateChange(date, "endDate")}
                  variant="inline"
                  inputVariant="outlined"
                  // minDate={new Date()}
                  format="dd/MM/yyyy"
                />
              </MuiPickersUtilsProvider>
            </FormControl>
            <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
              <InputLabel id="zone-label">Zone</InputLabel>
              <Select
                labelId="zone-label"
                id="zone-outlined"
                name="zone"
                value={zoneFilter}
                onChange={handleFilterChange}
                label="Zone"
              >
                {zoneFilterList.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
              <InputLabel id="ward-label">Ward</InputLabel>
              <Select
                labelId="ward-label"
                id="ward-outlined"
                name="ward"
                value={wardFilter}
                onChange={handleFilterChange}
                label="Ward"
              >
                {wardFilterList.map((item) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
              <InputLabel id="ccms-label">UID</InputLabel>
              <Select
                labelId="ccms-label"
                id="ccms-outlined"
                name="ccms"
                value={ccmsFilter}
                onChange={handleFilterChange}
                label="UID"
              >
                {ccmsFilterList.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
            <Button
              variant="contained"
              className="ml-auto reports-apply-btn"
              onClick={handleFilterApply}
            >
              Apply
            </Button>
          </div>
        </Grid>
      </Grid>

      <div className="dashboard-table">
        <MaterialTable
          style={{
            margin: "20px 0",
            width: "100%",
          }}
          className={classes.table}
          title=""
          columns={getOpReportColumnList()}
          data={opReportData}
          onRowClick={(evt, rowData) => {
            console.log("row click", evt, rowData);
            // setSelectedRowData(rowData);
            // setIsErrorDialogOpen(true);
          }}
          options={{
            exportButton: true,
            exportAllData: true,
            exportCsv: (columns, csvData) => { exportMaterialTableToExcel(columns, csvData, `Lamp Failure Report-${getDateString()}`); },
            exportPdf: (columns, csvData) => { exportMaterialTableToPDF(columns, csvData, `Lamp Failure Report-${getDateString()}`, 8, 18); },
            // exportCsv: (columns, data) => ExportCsv(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`,","),
            // exportPdf: (columns, data) => ExportPdf(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`),
            // grouping: true,
            search: true,
            selection: false,
            sorting: true,
            pageSize: 10,
            // rowStyle: (rowData) => ({
            //   backgroundColor:
            //     rowData?.ccmsNumber === selectedRowData?.ccmsNumber
            //       ? "#f0f2f4"
            //       : "",
            // }),
            headerStyle: {
              backgroundColor: "#0071CE",
              color: "#FFF",
              fontSize: "0.9em",
              textAlign: "center",
            },
            actionsColumnIndex: -1,
            emptyRowsWhenPaging: false,
          }}
          localization={{
            toolbar: {
              searchPlaceholder: "Search",
              exportCSVName: "Export as Excel",
              exportPDFName: "Export as PDF",
            },
          }}
        />
      </div>
    </div>
  );
};
export default LampFailureReport;
